// extracted by mini-css-extract-plugin
export default {"SpinnerContainer":"CenteredLoadingSpinner-module__SpinnerContainer__arM6dSF"};